let modals = {
    'base': require('../components/modals/BaseModal').default,
    'confirm': require('../components/modals/ConfirmModal').default,
};

export default {
    requiredPlugins: ['i18n', 'queue'],

    install(Vue) {
        Vue.component('modals', require('../components/Modals').default);
        Vue.component('base-modal', require('../components/modals/BaseModal').default);

        Vue.$modal = Vue.prototype.$modal = {
            register(name, component) {
                if (name instanceof Object) {
                    Object.entries(name).forEach(([name, component]) => Vue.$modal.register(name, component));
                    return;
                }
                modals[name] = component;
            },

            exists(name) {
                return modals.hasOwnProperty(name);
            },

            open(name, props, listeners = {}) {
                if (typeof name === "object" && typeof props === "undefined") {
                    listeners = props || {};
                    props = name;
                    name = 'base';
                }

                let component;
                if (name instanceof Object) {
                    component = name;
                } else {
                    if (!Vue.$modal.exists(name)) {
                        throw `Unknown modal: ${name}`;
                    }
                    component = modals[name];
                }

                Vue.$loading('modal', false);
                return Vue.$queue.push('modal', {component, props}, listeners);
            },

            alert(props = {}) {
                if (typeof props !== "object") {
                    props = {body: props || undefined};
                }

                let {btnOk, ...other} = props;
                let closeModal = Vue.$modal.open({
                    class: 'alert-modal',
                    actions: [{
                        label: btnOk || Vue.__('modal/ok'),
                        theme: 'light',
                        action: () => closeModal(),
                    }],
                    ...other,
                });

                return closeModal;
            },

            error(props = {}) {
                if (typeof props !== "object") {
                    props = {text: props || undefined};
                }

                let {title, text, ...other} = props;
                return Vue.$modal.open({
                    class: 'error-modal',
                    title: title || Vue.__('modal/error_title'),
                    body: text || Vue.__('modal/error_text'),
                    ...other,
                });
            },

            confirm(props = {}, listeners = {}) {
                return Vue.$modal.open('confirm', props, listeners);
            },
        };

        Vue.mixin({
            beforeCreate() {
                if (this.$options.modals instanceof Object) {
                    Vue.$modal.register(this.$options.modals);
                }
            },
        });
    },
};